import { specialCountries as DEFAULT_SPECIAL_COUNTRY_CODES } from "../../../../components/organisms/daSectionTiles/addressForm/receiverAddress/constant";
import { normalizeCountryGeoId } from "../../../../utils/myAccount/accountAddressForm";

export const ACCOUNT_ADDRESS_DOORBELL_LABEL = "Doorbell Name:";

/**
 * @param {string | undefined | null} specialCountriesConfig
 * @returns {string[]}
 */
export function resolveSpecialCountryCodes(specialCountriesConfig) {
  if (specialCountriesConfig && String(specialCountriesConfig).trim()) {
    return String(specialCountriesConfig)
      .split(",")
      .map((code) => normalizeCountryGeoId(code))
      .filter(Boolean);
  }
  return DEFAULT_SPECIAL_COUNTRY_CODES.map((code) => normalizeCountryGeoId(code));
}

/**
 * @param {object | undefined | null} address
 * @returns {string}
 */
export function getAddressDoorBellValue(address) {
  if (!address) {
    return "";
  }
  return String(address.doorBell ?? address.doorBellName ?? address.doorbellName ?? address.door_bell ?? "").trim();
}

/**
 * Doorbell is only captured on non-India address forms.
 *
 * @param {object | undefined | null} address
 * @returns {boolean}
 */
export function shouldShowAddressDoorBell(address) {
  const doorBell = getAddressDoorBellValue(address);
  if (!doorBell) {
    return false;
  }
  const countryId = normalizeCountryGeoId(address?.countryGeoId ?? address?.countryId ?? address?.country);
  return countryId !== "IND";
}

/**
 * @param {object} item
 * @returns {object}
 */
export function normalizeAccountAddressListItem(item) {
  if (!item || typeof item !== "object") {
    return item;
  }
  const doorBell = getAddressDoorBellValue(item);
  return {
    ...item,
    doorBell: doorBell || item.doorBell,
    doorBellName: doorBell || item.doorBellName,
    countryGeoId: normalizeCountryGeoId(item.countryGeoId ?? item.countryId ?? item.country ?? "IND"),
    address1: item.address1 ?? item.address,
    address: item.address ?? item.address1,
    phone: item.phone ?? item.mobileNumber,
    toName: item.toName ?? item.name,
    postalCode: item.postalCode ?? item.postalcode,
  };
}

/**
 * @param {object | undefined | null} address
 * @returns {string}
 */
export function getAddressContactMechId(address) {
  if (!address) {
    return "";
  }
  return address.id ?? address.contactMechId ?? address.postalAddress ?? "";
}
